import React from "react";

function Bar({ width, height = 12, style = {} }) {
  return (
    <div
      className="sk-bar"
      style={{ width, height, borderRadius: 6, display: "block", ...style }}
    />
  );
}

/* ── 4 stat cards ── */
function StatsGridSkeleton() {
  return (
    <div className="dash-stats-grid">
      {/* Today's Time (dark card) */}
      <div className="dash-stat-card dash-stat-card--dark" style={{ opacity: 0.55 }}>
        <Bar width={80} height={10} style={{ marginBottom: 12 }} />
        <Bar width={100} height={28} style={{ borderRadius: 8, marginBottom: 14 }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <Bar width="100%" height={6} style={{ borderRadius: 3 }} />
          <Bar width={90} height={9} />
        </div>
      </div>

      {/* This Week */}
      <div className="dash-stat-card">
        <Bar width={70} height={10} style={{ marginBottom: 12 }} />
        <Bar width={90} height={28} style={{ borderRadius: 8, marginBottom: 10 }} />
        <Bar width={80} height={9} />
      </div>

      {/* Active Projects */}
      <div className="dash-stat-card">
        <Bar width={90} height={10} style={{ marginBottom: 12 }} />
        <Bar width={48} height={28} style={{ borderRadius: 8, marginBottom: 10 }} />
        <Bar width={110} height={9} />
      </div>

      {/* Time Tracker */}
      <div className="dash-stat-card">
        <Bar width={80} height={10} style={{ marginBottom: 12 }} />
        <Bar width={110} height={28} style={{ borderRadius: 8, marginBottom: 10 }} />
        <Bar width={100} height={22} style={{ borderRadius: 20 }} />
      </div>
    </div>
  );
}

/* ── bar chart skeleton ── */
function ChartSkeleton() {
  // pixel heights out of ~160px usable bar area
  const heights = [88, 128, 64, 152, 96, 120, 160];
  return (
    <div className="dash-card">
      <div className="dash-card-header">
        <div>
          <Bar width={110} height={14} style={{ marginBottom: 6 }} />
          <Bar width={160} height={10} />
        </div>
        <Bar width={90} height={10} style={{ borderRadius: 10 }} />
      </div>
      <div className="dash-card-body dash-chart-body" style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
        {heights.map((h, i) => (
          <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
            <div
              className="sk-bar"
              style={{ width: "100%", height: h, borderRadius: "6px 6px 0 0" }}
            />
            <div className="sk-bar" style={{ width: 22, height: 9, borderRadius: 4 }} />
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── projects panel skeleton ── */
function ProjectsPanelSkeleton() {
  return (
    <div className="dash-card">
      <div className="dash-card-header">
        <div>
          <Bar width={70} height={14} style={{ marginBottom: 6 }} />
          <Bar width={100} height={10} />
        </div>
        <Bar width={50} height={28} style={{ borderRadius: 8 }} />
      </div>
      <div className="dash-card-body" style={{ display: "flex", flexDirection: "column", gap: 14, padding: "12px 20px" }}>
        {[80, 110, 90, 120, 70].map((w, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div className="sk-bar" style={{ width: 10, height: 10, borderRadius: "50%", flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <Bar width={w} height={11} style={{ marginBottom: 5 }} />
              <Bar width={w * 0.6} height={9} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── exported composite ── */
export default function DashboardSkeleton() {
  return (
    <>
      <StatsGridSkeleton />
      <div className="dash-middle-row">
        <ChartSkeleton />
        <ProjectsPanelSkeleton />
      </div>
    </>
  );
}
